import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const typographyFn = /* @__PURE__ */ createRecipe('MDSText', {
  "variant": "body-xl"
}, [])

const typographyVariantMap = {
  "variant": [
    "d1",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1-B",
    "subtitle1-M",
    "subtitle2-B",
    "subtitle2-M",
    "subtitle3-B",
    "subtitle3-M",
    "subtitle4-B",
    "subtitle4-M",
    "body1-R",
    "body2-R",
    "body3-R",
    "body4-R",
    "body1-B",
    "body2-B",
    "body3-B",
    "body4-B",
    "caption1-M",
    "caption1-R",
    "caption2-M",
    "caption2-R",
    "caption3-M",
    "caption3-R",
    "button-XL",
    "button-L",
    "button-M",
    "button-S",
    "chat-body1-R",
    "nanum-h1",
    "nanum-h2",
    "nanum-title1",
    "nanum-title2",
    "nanum-title3",
    "nanum-body1-EB",
    "nanum-body1-B",
    "nanum-body2-EB",
    "nanum-body2-B",
    "nanum-body3-EB",
    "nanum-body3-B",
    "nanum-body4-EB",
    "nanum-body4-B",
    "nanum-body5-EB",
    "nanum-body5-B",
    "nanum-caption1-EB",
    "nanum-caption1-B",
    "nanum-caption2-EB",
    "nanum-caption2-B",
    "nanum-caption3-EB",
    "nanum-caption3-B",
    "headline-lg",
    "headline-md",
    "headline-sm",
    "title-2xl",
    "title-xl",
    "title-lg",
    "title-lg-medium",
    "title-md",
    "title-md-medium",
    "title-sm",
    "title-sm-medium",
    "title-xs",
    "title-xs-medium",
    "body-xl",
    "body-lg",
    "body-md",
    "body-sm",
    "body-xl-semibold",
    "body-lg-semibold",
    "body-md-semibold",
    "body-sm-semibold",
    "caption-lg",
    "caption-lg-medium",
    "caption-md",
    "caption-md-medium",
    "caption-sm",
    "caption-sm-medium",
    "contents-xl",
    "contents-lg",
    "contents-md",
    "contents-sm",
    "chat-subtitle",
    "chat-body",
    "chat-caption-M",
    "chat-caption-R",
    "chat-small-text-M",
    "chat-small-text-R"
  ],
  "bold": [
    "true"
  ]
}

const typographyVariantKeys = Object.keys(typographyVariantMap)

export const typography = /* @__PURE__ */ Object.assign(memo(typographyFn.recipeFn), {
  __recipe__: true,
  __name__: 'typography',
  __getCompoundVariantCss__: typographyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: typographyVariantKeys,
  variantMap: typographyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, typographyVariantKeys)
  },
  getVariantProps: typographyFn.getVariantProps,
})